import {TimelineLite, TweenLite, TweenMax} from "gsap";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {FontStyleConfig} from "../../../config/FontConfig";
import {BitmapCountUp} from "../../../coutup/BitmapCountUp";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TheRaveSound} from "../../../sound/TheRaveSound";

export class BigWinCountUp extends PIXI.Container {

    protected _countUp:BitmapCountUp;
    private _endingScale:number = 0.6;
    private landscapeY:number = 0.6;
    private portraitY:number = 0.6;

    constructor(layer:StageLayer, yPosition:number, portraitY:number) {
        super();

        const style = FontStyleConfig.COUNT_UP_BIG_WIN;
        this._countUp = new BitmapCountUp(style);
        //this._countUp.shrinkSize = true;
        this.portraitY = portraitY?portraitY:yPosition;
        this.landscapeY = yPosition;
        this.addChild(this._countUp);
        this._countUp.anchor = 0.5;
        this.position.set(360, yPosition);
        layer.addChild(this);
        this.visible = false;
    }

    public getCountUpAnimation(from:number, to:number, duration:number):TimelineLite {
        const tl = new TimelineLite();
        tl.add([
            () => {
                this._countUp.maxTextWidth = 580;
                this._countUp.scale.set(1);
                this._countUp.alpha = 1;
                this._countUp.visible = true;
                this.onOrientationChanged();
                this.visible = true;
            },
            this._countUp.getBwCountUpAnimation(from, to, {duration:duration - 0.3, withoutSound:true})
        ]);
        tl.add(TweenMax.to(this.scale, 0.1, {
            x: 1.25,
            y: 1.25
        }));
        tl.add(TweenMax.to(this.scale, 0.1, {
            x: 1.25,
            y: 1.25
        }));
        tl.add(TweenMax.to(this.scale, 0.1, {
            x: 1,
            y: 1
        }));
        tl.add(() => {
            ()=>{TheRaveSound.stopSoundEffect("countup")}
        });


        return tl;
    }

    public stay():TimelineLite {
        const tl = new TimelineLite();
        const endScale:number = this._countUp.scale.y*1.1;
        tl.add([
            TweenLite.to(this._countUp.scale, {
                duration : 0.5,
                x :endScale,
                y : endScale,
                ease : `elastic.out(1, 1)`
            })
        ]);
        // timeline.add(() => ElPasoGunfightSoundConfig.soundPlayer.playTrack({name : ElPasoGunfightSoundConfig.instance.COUNT_UP_END_FALL_BACK}), "-=0.3");
        return tl;
    }

    public remove():TimelineLite {
        const tl = new TimelineLite();
        if(this._countUp.visible) {
            tl.add(TweenLite.to(this._countUp, {duration : 0.5, alpha : 0, y : -100, ease : `power2.in`}), `+=0.2`); // stay a short while after count up.
            tl.add(() => this.reset());
        }
        return tl;
    }

    public reset():void {
        this._countUp.y = 0;
        this._countUp.visible = false;
        this.visible = false
    }

    public setColor(color:number):void {
        this._countUp.tint = color;
    }

    public onOrientationChanged():void{
        if(this.visible){
            this.y = (NolimitApplication.isLandscape?this.landscapeY:this.portraitY);
        }
    }
}